var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.732942 7.58045C0.223787 7.36725 0.229777 7.05005 0.766885 6.86389L19.8213 0.247349C20.3494 0.0643077 20.6519 0.37215 20.5041 0.910875L15.0592 20.7605C14.9094 21.3107 14.5849 21.3356 14.3433 20.8333L9.7949 11.3557L0.732942 7.58045ZM5.61484 7.37245L11.2415 9.71767L14.2765 16.043L17.8166 3.1365L5.61384 7.37245H5.61484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.893ff6a088eac055158022afbeb74323.svg";
export { ForwardRef as ReactComponent };